import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import menuReducer from './menuSlice';
import eventsReducer from './eventsSlice';
import tokensReducer from './tokensSlice';
import promoReducer from './promoSlice';
import statsReducer from './statsSlice';

// Połącz wszystkie reducery
const rootReducer = combineReducers({
  menu: menuReducer,
  events: eventsReducer,
  tokens: tokensReducer,
  stats: statsReducer,
  promo: promoReducer
});

// Konfiguracja persist
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: [
    'menu',
    'events',
    'tokens',
    'promo'
  ],
  migrate: (state) => {
    if (!state) {
      return Promise.resolve(state);
    }

    const promo = state.promo;
    if (promo && !promo.filters) {
      return Promise.resolve({
        ...state,
        promo: {
          ...promo,
          filters: {
            dateFrom: '',
            dateTo: '',
            promotionType: '',
            status: '',
          },
          totalCount: promo.totalCount ?? 0,
        },
      });
    }

    return Promise.resolve(state);
  },
};

// Stwórz persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Konfiguracja store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        },
      }),
});

// Stwórz persistor
export const persistor = persistStore(store);

export default store;
